import { render, staticRenderFns } from "./xbn_swap.vue?vue&type=template&id=87fabbc4&"
import script from "./xbn_swap.vue?vue&type=script&lang=js&"
export * from "./xbn_swap.vue?vue&type=script&lang=js&"
import style0 from "./xbn_swap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports